import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-form-validator-core";
import WithoutMsgValidation from "../../../../Forms/FormLayouts/WithoutMsgValidation";
import Select from 'react-select';
import { CONSTANTS } from "../../../../../helpers/constants";

const FORM_TYPES = [
  { value: 'matriz_meddi', label: 'Matriz Meddi' },
  { value: 'sistema_de_apoyos', label: 'Sistema de apoyos' }
]

const EditFormModal = ({ visible, currentForm, closeHandler, successCallback, failCallback }) => {
  const [formData, setFormData] = useState({});

  const handleSendForm = async () => {
    const req = await fetch(`${CONSTANTS.base_url}api/v1/data/form/${formData.formId}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-access-token': CONSTANTS.TOKEN
      },
      body: JSON.stringify({
        form_name: formData.formName,
        form_description: formData.formDescription,
        form_type: formData.formType
      })
    });
    const res = await req.json();
    res.success ? successCallback(formData) : failCallback(res);
    setFormData({});
  }
  const handleClose = () => {
    setFormData({});
    closeHandler();
  }

  useEffect(() => {
    setFormData({
      formId: currentForm.form_id,
      formName: currentForm.form_name,
      formDescription: currentForm.form_description,
      formType: currentForm.form_type
    });
  }, [currentForm])

  return (
    <Modal show={visible} onHide={handleClose} onEscapeKeyDown={handleClose} onExit={handleClose}>
      <ValidatorForm instantValidate={true} onSubmit={handleSendForm} className="p-t-15">
        <Modal.Header closeButton>
          <h4>Editar formulario: <b>{currentForm.form_name}</b></h4>
        </Modal.Header>
        <Modal.Body>
          <p className="small-text">{currentForm.form_description}</p>
          <div className="row">
            <div className="col-md-12">
              <WithoutMsgValidation
                onChange={(e) => setFormData({ ...formData, formName: e.target.value })} value={formData?.formName || ''}
                name="formName" placeholder="Nombre del formulario" type="text"
                validators={["required"]} errorMessages={["Este campo es obligatorio"]} className={"form-control"} label="Nombre" require="true"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <WithoutMsgValidation
                onChange={(e) => setFormData({ ...formData, formDescription: e.target.value })} value={formData?.formDescription || ''}
                name="formDescription" placeholder="Descripción del formulario" type="text"
                validators={["required"]} errorMessages={["Este campo es obligatorio"]} className={"form-control"} label="Descripción" require="true"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Select name="formType" defaultValue={FORM_TYPES.filter(({ value }) => value === currentForm.form_type)[0]} options={FORM_TYPES}
                onChange={(e) => setFormData({ ...formData, formType: e.value })}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary btn-cons" type="submit">Guardar</button>
          <div className="btn btn-cons" onClick={closeHandler}>Cancelar</div>
        </Modal.Footer>
      </ValidatorForm>
    </Modal>
  );
};

export default EditFormModal;
